import { Link } from 'react-router';
import { tripPaths } from '../../trips/trips.paths';
import { unitPath } from '../../fleet/features/units/units.paths';
import type { AlertView } from '../alerts.api';

/**
 * The truck, linked to where the operator goes next: the trip it is on if it is on one, otherwise the truck's own page. An alert is
 * about a truck only (trip-scoped alerts are not built), so there is no alert detail screen to open.
 */
export function AlertTruckCell({ alert }: { alert: AlertView }) {
  const { currentTrip } = alert;
  return (
    <div className="flex flex-col items-start">
      <Link className="font-medium" to={currentTrip ? tripPaths.trip(currentTrip.id) : unitPath(alert.truckRegistration)}>
        {alert.truckRegistration}
      </Link>
      {currentTrip && <span className="text-xs text-muted">On trip {currentTrip.number}</span>}
    </div>
  );
}
